/* Obroč zadnjih N klicev na API — kontekst, ki se priloži prijavi napake.
   [PATCH napake-fe v1]

   NAMENOMA ne hrani glav, žetonov, teles zahtev ali odgovorov —
   samo metodo, pot, status in morebitno sporočilo napake.
   Beleženje ne sme nikoli podreti klica, zato je vse v try/catch. */

export interface ApiZapis {
  cas: string;
  metoda: string;
  pot: string;
  status: number | string;
  napaka?: string;
}

const MAX = 20;
let obroc: ApiZapis[] = [];

export function zabeleziOdziv(config: any, status: any, napaka?: string) {
  try {
    const z: ApiZapis = {
      cas: new Date().toISOString(),
      metoda: String((config && config.method) || '?').toUpperCase(),
      pot: String((config && config.url) || '?').slice(0, 200),
      status: (status === undefined || status === null) ? 'brez odziva' : status,
    };
    if (napaka) z.napaka = String(napaka).slice(0, 200);
    obroc.push(z);
    if (obroc.length > MAX) obroc = obroc.slice(obroc.length - MAX);
  } catch {
    /* tiho */
  }
}

export function zadnjiKlici(): ApiZapis[] {
  return obroc.slice();
}
